export default __webpack_public_path__ + "static/artboard-47-892b1ffc01bdd3919518f1dcc1946104.png";